<template>
  <div class="my-contract" >
    <div @click="gotoMyContract" >
      <span>Mon espace de travail:</span>
      <span v-if="contract === null" >
        Aucun
      </span>
      <span v-else >
        {{ contract.name }}
      </span>
      <span class="el-icon-fa-exchange" @click.stop="showModal = true" ></span>
    </div>
    <el-dialog
       title="Choisir mon espace de travail"
       :visible.sync="showModal"
        >
      <el-form :inline="true" >
        <el-form-item>
          <el-select
             v-model="selectedContract"
             value-key="id"
             :remote="true"
             :filterable="true"
             placeholder="Rechercher un espace de travail"
             :remoteMethod="searchAvailableContract"
             :loading="loading" >
            <el-option v-for="c in contracts" :key="c.id" :label="c.name" :value="c" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="validate" >Valider</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {api} from 'macarons'

export default {
  data () {
    return {
      showModal: false,
      contracts: [],
      selectedContract: null,
      loading: false,
      debounce: null
    }
  },
  computed: {
    contract () {
      return this.$store.state.chloe.contract
    }
  },
  mounted () {
    this.loading = true
    api.post('contract/autocomplete').then(({data}) => {
      this.contracts.splice(0, this.contracts.length, ...data)
      this.selectedContract = this.contract
      this.loading = false
    })
  },
  methods: {
    searchAvailableContract (query) {
      this.loading = true
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        api.post('contract/autocomplete', { q: query }).then(({data}) => {
          this.contracts.splice(0, this.contracts.length, ...data)
          this.loading = false
        })
      }, 300)
    },
    validate () {
      api
        .get('user/contract/' + (this.selectedContract === null ? 'null' : this.selectedContract.id))
        .then(() => {
          this.$store.commit('setContract', this.selectedContract)
          this.showModal = false
          this.$store.dispatch('load').then(() => {
            if (this.$router.currentRoute.name.substr(0, 5) === 'board') {
              this.$router.push('/')
            } else if (this.$router.currentRoute.name.substr(0, 4) === 'home') {
              this.$router.go()
            }
          })
        })
    },
    gotoMyContract () {
      // if (this.contract === null) {
      //   return
      // }
      // this.$router.push('/my-contract')
    }
  }
}
</script>

<style scoped>
.el-icon-fa-exchange {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/contracts/components/MyContract.vue